module.exports = __webpack_public_path__ + "img/ligne.2cb2027f.png";